// extracted by mini-css-extract-plugin
module.exports = {"gameButton":"GameModeList_gameButton__1jsyP","selected":"GameModeList_selected__2_59f"};